<template>
  <section class="container p-10 my-20 text-center border rounded-lg shadow">
    <h2>Final&nbsp;prices. No&nbsp;surprises.</h2>
    <CheckoutRouteForm />
    <p class="mt-5 -mb-5 text-sm">No surprises. All prices are including VAT, tolls, fuel, parking fee and other expenses related to car.</p>
  </section>

  <ContentCarClasses />

  <div class="bg-indigo-100">
    <div class="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:flex lg:items-center lg:justify-between lg:px-8">
      <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Need something special?<br />Customized journeys tailored for you</h2>
      <div class="mt-10 flex items-center gap-x-6 lg:mt-0 lg:flex-shrink-0">
        <NuxtLink to="/services/customized-trip" class="text-sm font-semibold leading-6 text-gray-900">Learn more <span aria-hidden="true">→</span></NuxtLink>
      </div>
    </div>
  </div>
</template>
